import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { ModuleModel } from 'src/app/models/authentication/module.model';
import { WindowModel } from 'src/app/models/authentication/window.model';
import { ModuleService } from 'src/app/services/authentication/module.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-permissions-company',
  templateUrl: './permissions-company.component.html',
  styleUrls: ['./permissions-company.component.scss'],
  standalone: false
})
export class PermissionsCompanyComponent implements OnInit {

  companyId: number = 0;
  disabledForm: boolean = false;
  appModules: ModuleModel[] = [];
  modules: ModuleModel[] = [];
  modulesCompanyId: number[] = [];
  subscription: Subscription;
  swFreight: boolean = false;
  swModuleOrder: boolean = false;
  swAppMovil: boolean = false;
  webModules: ModuleModel[] = [];
  windows: WindowModel[] = [];
  windowsCompanyId: number[] = [];

  constructor(public config: DynamicDialogConfig,
    private generalParameterService: GeneralParameterService,
    private moduleService: ModuleService,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.companyId = inputs.companyId;
      this.disabledForm = inputs.disabledForm;
    });
    await this.getGeneralParametersByCompany();
    await this.getModulesAndWindowsByCompany();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  changeModule(moduleId: number) {
    const index = this.modulesCompanyId.indexOf(moduleId);
    const module = this.modules.find(m => m.moduleId == moduleId) as ModuleModel;
    const windowsId = module.windows.map(w => w.windowId);
    if (index == -1) {
      this.modulesCompanyId.push(moduleId);
      for (const id in windowsId) {
        if (this.windowsCompanyId.indexOf(windowsId[id]) == -1) {
          this.windowsCompanyId.push(windowsId[id]);
        }
      }
    } else {
      this.modulesCompanyId.splice(index, 1);
      for (const id in windowsId) {
        const indexWindow = this.windowsCompanyId.indexOf(windowsId[id]);
        if (indexWindow != -1) {
          this.windowsCompanyId.splice(indexWindow, 1);
        }
      }
    }
  }

  changeWindow(windowId: number) {
    const index = this.windowsCompanyId.indexOf(windowId);
    const window = this.windows.find(w => w.windowId == windowId) as WindowModel;
    if (index == -1) {
      this.windowsCompanyId.push(windowId);
      if (this.modulesCompanyId.indexOf(window.moduleId) == -1) {
        this.modulesCompanyId.push(window.moduleId);
      }
    } else {
      this.windowsCompanyId.splice(index, 1);
      const module = this.modules.find(m => m.moduleId == window.moduleId) as ModuleModel;
      const windowsModuleId = module.windows.map(w => w.windowId);
      let countWindow = 0;
      for (const id in windowsModuleId) {
        if (this.windowsCompanyId.indexOf(windowsModuleId[id]) != -1) {
          countWindow = countWindow + 1;
        }
      }
      if (countWindow == 0) {
        const indexModule = this.modulesCompanyId.indexOf(module.moduleId);
        this.modulesCompanyId.splice(indexModule, 1);
      }
    }
  }

  async getModulesAndWindowsByCompany() {
    try {
      const [webModules, appModules, windows, modulesByCompany, windowsByCompany] = await Promise.all([
        firstValueFrom(this.moduleService.getAllModulesByPlatform(true)),
        this.swAppMovil
          ? firstValueFrom(this.moduleService.getAllModulesByPlatform(false))
          : Promise.resolve<ModuleModel[]>([]),
        firstValueFrom(this.windowService.getAllWindow()),
        firstValueFrom(this.moduleService.getMenuByCompany(this.companyId)),
        firstValueFrom(this.windowService.getWindowsByCompany(this.companyId))
      ]);
      this.webModules = webModules;
      this.appModules = appModules;
      this.modules = [...webModules, ...appModules];
      this.windows = windows;
      this.modulesCompanyId = modulesByCompany.map(m => m.moduleId);
      this.windowsCompanyId = windowsByCompany.map(w => w.windowId);
    } catch (error) {
      console.error('Error al cargar módulos y ventanas.', error);
    }
  }

  async getGeneralParametersByCompany() {
    try {
      const generalParameters = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId));
      this.swModuleOrder = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.moduloPedidos);
      this.swFreight = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.generaFletes);
      this.swAppMovil = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.appMovil);
    } catch (error) {
      console.error('Error al obtener los parámetros generales.', error);
    }
  }

  getTagModule(module: ModuleModel) {
    const moduleEnable = this.modulesCompanyId.indexOf(module.moduleId) != -1;
    return moduleEnable ? 'success' : 'danger';
  }

  getTagTextModule(module: ModuleModel) {
    const moduleEnable = this.modulesCompanyId.indexOf(module.moduleId) != -1;
    return moduleEnable ? 'Habilitado' : 'Inhabilitado';
  }

  async savePermissions() {
    //Valido si SwGenera fletes este activo para habilitar ventanas
    if (!this.swFreight && this.windowsCompanyId.some(x => x === WindowEnums.Freight || x === WindowEnums.Sector)) {
      this.toastHandlerService.showToast(
        'error',
        `Para habilitar Sector y/o Fletes debe estar habilitado el sw de Fletes en parámetros generales.`
      );
      return;
    }
    //Si están activando la pedidos o art. generico, válido que el modulo de pedidos también esta habilitado
    if (!this.swModuleOrder && this.windowsCompanyId.some(x => x === WindowEnums.Order || x === WindowEnums.ArticleGeneric)) {
      this.toastHandlerService.showToast(
        'error',
        `Para habilitar Pedidos y/o Artículos Genéricos debe estar habilitado el módulo de pedidos en parámetros generales.`
      );
      return;
    }
    try {
      const [modules, windows] = await Promise.all([
        this.saveModulesByCompany(),
        this.saveWindowsByCompany(),
      ]);
      this.modulesCompanyId = modules;
      this.windowsCompanyId = windows;
      this.toastHandlerService.showToast(
        'success',
        'Los permisos fueron guardados exitosamente.'
      );
    } catch (error) {
      console.error('Error al guardar permisos:', error);
    }
  }

  private saveModulesByCompany(): Promise<number[]> {
    return firstValueFrom(
      this.moduleService.saveModulesByCompany(this.companyId, this.modulesCompanyId)
    );
  }

  private saveWindowsByCompany(): Promise<number[]> {
    return firstValueFrom(
      this.windowService.saveWindowsByCompany(this.companyId, this.windowsCompanyId)
    );
  }
}
